import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { Helmet } from 'react-helmet';
import { truncateDescription } from './SchemaOrg/utils/description';
import { getImage } from './SchemaOrg/utils/image';
import { ImagesPropType } from '../../services/proptypes';
import { getImageSrc } from '../../utils/images';
var defaultProps = {
  images: [],
  description: '',
  title: '',
  truncateDescription: false
};
export default function SEO(_ref) {
  var businessName = _ref.businessName,
    pageName = _ref.pageName,
    description = _ref.description,
    title = _ref.title,
    truncateDescriptionProp = _ref.truncateDescription,
    images = _ref.images;
  var imageSrc = getImageSrc(getImage(images));
  var finalDescription = truncateDescriptionProp ? truncateDescription(description) : description;
  var finalTitle = title || "".concat(pageName, " | ").concat(businessName);
  var seo = {
    title: finalTitle,
    description: finalDescription
  };
  if (!_isEmpty(imageSrc)) {
    seo = _objectSpread(_objectSpread({}, seo), {}, {
      image: imageSrc
    });
  }
  return /*#__PURE__*/React.createElement(Helmet, {
    title: seo.title,
    defer: false
  }, seo.description && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: seo.description
  }), seo.image && /*#__PURE__*/React.createElement("meta", {
    name: "image",
    content: seo.image
  }));
}
SEO.defaultProps = defaultProps;